module.exports = __webpack_public_path__ + "static/media/wind_gust_2.400b644a.png";